import { LocalStorage } from '@hotjar/insights-common/lib/storage-factory';
import type { GetState, SetState, StoreApi } from 'zustand';
import { getPlaylistVisibility } from '../../../../utils/getPlaylistVisibility';
import type { State, PlaylistSlice } from '../../types';
import { PLAYLIST_TOGGLE_PREFERENCE_KEY } from '../recordingsListSlice/constants';

export const createPlaylistSlice: (
  set: SetState<State>,
  get: GetState<State>,
  api: StoreApi<State>,
) => PlaylistSlice = (set) => {
  const playlistTogglePreference = LocalStorage.get('playlistTogglePreference');

  return {
    playlistVisible: getPlaylistVisibility(),
    playlistOpened: playlistTogglePreference !== 'closed',
    lastFetchedRecordingId: null,

    setPlaylistOpened: (playlistOpened: boolean) => {
      LocalStorage.set(PLAYLIST_TOGGLE_PREFERENCE_KEY, playlistOpened ? 'opened' : 'closed');
      set({ playlistOpened });
    },
    setPlaylistVisible: (playlistVisible: boolean) => set({ playlistVisible }),
    setLastFetchedRecordingId: (lastFetchedRecordingId: number) => set({ lastFetchedRecordingId }),
  };
};
